<template>
  <H5 v-if="isMobile" />
  <PC v-else />
</template>

<script lang="ts" setup>
import { ENUM_PageName, E_RECOMMEND_CATEGORY } from '~/enums'
import PC from '~/pages/desktop/experience/detail/index.vue'
import H5 from '~/pages/mobile/experience/detail/index.vue'
import ogImageUrl from '~/assets/logo.png'

definePageMeta({
  pageCategory: ENUM_PageName.Detail,
})

const isMobile = useMobileByScreen()
const route = useRoute()
const dayjs = useDayjs()
const {
  filterParams,
  serialNo,
  initFilter,
  getExperienceDetail,
  trackViewItem,
  experienceInfo,
} = useExperienceDetail()
const userInfoStore = useUserStore()
const { addRecentViewdStore } = useSearchResult()
const { t } = useI18n()

watch(() => route.query, () => {
  filterParams.value.travelDate = dayjs(route.query.travelDate as string).format('YYYY-MM-DD')
}, { immediate: true })

useAutoScrollTop()

initFilter()
await getExperienceDetail()

useSeoMeta({
  title: () => t('key.detail.page.meta.title.new', [experienceInfo.value?.specialTopicName]),
  keywords: () => t('key.detail.page.meta.keywords.new', [experienceInfo.value?.specialTopicName]),
  description: () => t('key.detail.page.meta.desc.new', [experienceInfo.value?.specialTopicName]),
  ogImageUrl,
})

watch(() => userInfoStore.userInfo.currency, () => {
  getExperienceDetail()
})

onMounted(() => {
  trackViewItem()
  addRecentViewdStore(serialNo.value!, E_RECOMMEND_CATEGORY.EXPERIENCE)
})
</script>
